export const sanitize = (raw: string, reference: string) => {
  const tokens = reference.trim().split(/\s+/);
  const start = raw.indexOf(tokens[0]);
  const end = raw.lastIndexOf(tokens[tokens.length - 1]);

  if (start !== -1 && end !== -1)
    return raw.substring(start, end + tokens[tokens.length - 1].length);
  else if (start !== -1) return raw.substring(start);
  else if (end !== -1)
    return raw.substring(0, end + tokens[tokens.length - 1].length);
  return raw;
};
